let sessionId: string | null = null;

// for testing purpose only
export const _resetSessionId = () => {
  sessionId = null;
};

export const getSessionId = () => {
  if (!sessionId) {
    sessionId = window.__SESSION_ID__ || null;
  }

  return sessionId;
};
